import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { ReportContentService } from '../../services/ReportContent.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { DecisionEnum } from '../../models/reportedContent';
import { Record } from 'src/app/features/restaurants/models/List.GuestReviews';
export interface DialogData {
  record: Record
}
@Component({
  selector: 'app-report-content-resolve-form',
  templateUrl: './report-content-resolve-form.component.html'
})
export class ReportContentResolveFormComponent extends DirtyComponent implements OnInit {
  override formGroup!: FormGroup;
  dataLoading = false;
  loading = false;

  isUpdate: boolean = this.data.record.reportDecision ? true : false;

  constructor(
    override dialogRef: MatDialogRef<ReportContentResolveFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: ReportContentService,
    translate: TranslateService
  ) { super(translate); }

  ngOnInit(): void {
    this.buildForm();
    if (this.isUpdate) {
      this.bindDataToUpdate();
    }
  }


  buildForm() {
    this.formGroup = this.formBuilder.group({
      decisionType: [DecisionEnum.Keep],
      decisionComment: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(300)
      ]],
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  bindDataToUpdate() {
    this.formGroup.patchValue({
      decisionType: this.data.record.reportDecision[0].decisionType,
      decisionComment: this.data.record.reportDecision[0].resolutionComment
    });
  }

  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        reviewId: this.data.record.reviewId,
        decisionType: this.formGroup.controls['decisionType'].value,
        decisionComment: this.formGroup.controls['decisionComment'].value
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.saveRecord(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }
}
